import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {useLazyLogErrorQuery} from "@/api/siteApi";
import {ErrorInfo, useEffect} from "react";
import MetadataEventModel from "@Events/models/MetadataEventModel";
import useUser from "@User/hooks/useUser";

export default function useHandleAppErrors() {
    const {error, experiments} = useAppSelector((state) => (state.page))
    const [logError] = useLazyLogErrorQuery()
    const user = useUser()

    const getStaticData = () => ({
        url: window.location.href,
        viewPort: `${window.visualViewport.width} x ${window.visualViewport.height}`,
        metadata: MetadataEventModel(experiments, user?.userId),
    })

    const getErrorMessage = (error: Error | string) => {
        if (typeof error === "string") {
            return error
        }

        return error?.message ?? "Error"
    }

    const getAdditionalInfo = (info: ErrorInfo | string) => {
        if (typeof info === "string") {
            return info
        }

        return info?.componentStack ?? "Stack"
    }

    const getStackTrace = (stackTrace: string | undefined, error: Error | string) => {
        if (stackTrace) {
            return stackTrace
        }
        if (typeof error === "string") {
            return "StackTrace"
        }

        return error?.stack ?? "StackTrace"
    }

    useEffect(() => {
        if (error) {
            const {
                error: errorData,
                info,
                stackTrace,
            } = error

            logError({
                ...getStaticData(),
                errorMessage: getErrorMessage(errorData),
                additionalInfo: getAdditionalInfo(info),
                stackTrace: getStackTrace(stackTrace, errorData),
            })
        }
    }, [error]);
}